<template>
  <div class="home">
    <br /><br /><br /><br />
    <div class="homemain">
      <div class="vl"></div>
      <div>
        <span class="homemaintitle">Connecting<br/>Students<br/>Worldwide</span> <br />
        <br />
        <a href="/#/join" ><button>Join Now</button></a>
      </div>
      <img class="mainlogo" width="40%" src="@/assets/logo.png" alt="TACS Logo" />
    </div>
    <div class="homemain-mobile">
      <div class="homemaincontainer-mobile">
        <img class="mainlogo" width="40%" src="@/assets/logo.png" alt="TACS Logo" />
        <br />
        <span class="homemaintitle">Connecting Students Worldwide</span> <br />
        <br />
        <a href="/#/join" ><button>Join Now</button></a>
      </div>
    </div>
    <br /><br /><br /><br /><br /> <br />
    <div class="pheadcontainer">
      <span class="phead">Who are we?</span>
    </div>
    <hr />
    <p class="desc">
      We are a student-led community that realizes the lack of opportunity for<br />students 
      to join clubs in their schools. Our aim is to provide equal<br />
      opportunity to all high-school students to experience activities that they<br />would
      have otherwise experienced through their school clubs.
    </p>
    <p class="desc-mobile">
      We are a student-led community that realizes the lack of opportunity for students 
      to join clubs in their schools. Our aim is to provide equal opportunity to all high-school students to experience activities that they would
      have otherwise experienced through their school clubs.
    </p>
    <br />
    <div class="pheadcontainer">
      <span style="font-size: 30px" class="phead">Subscribe to our newsletter</span>
    </div>
    <hr />
    <p>Subscribe to our monthly newsletter to get all the information about our upcoming club activities and projects.</p>
    <div class="subscribe">
      <input type="email" id="news_email" name="email" placeholder="Enter your email address.." />
      <button>Sign&nbsp;Up</button>

    </div>
  </div>
</template>


<script>
export default {
  name: 'Home',
  mounted() {
    window.scrollTo({top: 0, behavior: "smooth"});
  },
}
</script>

<style scoped>
  @media screen and (max-width: 720px) {
    .homemain-mobile {
      display: block;
    }

    .homemain {
      display: none;
    }

    .homemaintitle {
      font-size: 5vw;
    }

    .homemaincontainer-mobile {
      text-align: center;
    }

    .mainlogo {
      padding-left: 0;
    }

    .pheadcontainer {
      text-align: center;
    }

    .footercontent {
      font-size: 10vw;
    }

    .desc {
      display: none;
    }

    .desc-mobile {
      display: block;
    }
  }
</style>